export class FiltroConcurso {
	id?: number;
	nome?: string;
	codigo?: string;
	utiliza_perfil?: boolean;
	situacao?: string;
	orientacao?: string;

	constructor(id?: number, nome?: string, codigo?: string, utiliza_perfil?: boolean, situacao?: string, orientacao?: string) {
		this.id = id;
		this.nome = nome;
		this.codigo = codigo;
		this.situacao = situacao;
		this.orientacao = orientacao;

		if (utiliza_perfil == undefined) {
			this.utiliza_perfil = false;
		} else {
			this.utiliza_perfil = utiliza_perfil;
		}
	}
}
